<template>
  <div class="generalPage">
    <isotopegrid v-bind:isotopeProps="isotopeProps"></isotopegrid>
    <!--div class="isotopeGrid">
      <div class="section2">
        <div class="generalWrapper">
          <h1>如何消滅它們</h1>
          <p>要徹底消滅螞蟻，關鍵是消滅整個螞蟻巢穴。 如果只是殺死眼前的螞蟻，其餘的螞蟻會繼續出末尋找食物和水源，以恭奉給蟻后和與其他同伴分享。</p>
          <p>威滅速效殺蟻藥餌可以將巢穴內的螞蟻一網打盡。想了解更多有關威滅一網打盡的原理，請按這裡。</p>
        </div>
      </div>
    </div-->
    <contact></contact>
    <henkel-footer></henkel-footer>
  </div>
</template>

<script>
export default {
  created () {
    window.document.title = '威滅Combat 速效藥餌'
    window.scrollTo(0, 0)
  },
  data () {
    return {
      isotopeProps: {
        title: '螞蟻小常識',
        desc: '害蟲種類及資訊',
        cardname: '螞蟻小常識',
        showTag: false,
        popup: true,
        popupContents: null,
        openPopup: false,
        list: [{
          name: '小黃家蟻',
          id: 0,
          imgpath: '',
          tag: '',
          cardname: '種類',
          html: `
            <h1 class="hdr">小黃家蟻</h1>
            <p>常見的螞蟻有小黃家蟻 (又名“法老蟻”)和黑蟻。</p>
            <h1>外表</h1>
            <p>小黃家蟻身型很小，體長為1.5毫米，呈淡黃褐色。</p>
          `
        }, {
          name: '黑蟻',
          id: 1,
          imgpath: '',
          tag: '',
          cardname: '種類',
          html: `
            <h1 class="hdr">黑蟻</h1>
            <p>常見的螞蟻有小黃家蟻 (又名“法老蟻”)和黑蟻。</p>
            <h1>外表</h1>
            <p>黑蟻身型中等，體長為2.5-3毫米，呈有光澤的黑色。</p>
          `
        }, {
          name: '螞蟻的食糧',
          id: 2,
          imgpath: '',
          tag: '',
          html: `
            <h1 class="hdr">螞蟻的食糧</h1>
            <p>它們喜歡吃甜的，有脂肪和蛋白質的食物。可是它們對食物的選擇經常改變不定。</p>
          `
        }, {
          name: '防止螞蟻入侵的方法',
          id: 3,
          imgpath: '',
          tag: '',
          html: `
            <h1 class="hdr">防止螞蟻入侵的方法</h1>
            <p>小黃家蟻難以控制，因為蟻群有可能在難以觸及的地方建築多個巢穴。切勿使用殺蟲噴霧劑來對付這些螞蟻，因為這些殺蟲噴霧劑的驅蟲作用會導致蟻群分散並加重禍患。此外，小黃家蟻很快從一個食物來源轉移到另一個食物來源，所以最好同時間使用數個殺蟻藥餌防止它們入侵。</p>
            <p>把外牆裂縫密封能夠防止黑蟻進入室內，亦應該修理漏水情況，不應過分灌溉植物，清理好剩餘的食物，並把食物存放在密封的容器中。</p>
          `
        }, {
          name: '築巢地點',
          id: 4,
          imgpath: '',
          tag: '',
          html: `
            <h1 class="hdr">築巢地點</h1>
            <h1>小黃家蟻</h1>
            <p>會在戶外或室內建築螞蟻巢。 它們喜歡在充足溫暖和濕度的環境，並在難以觸及的地方下築巢，如牆內空隙、廚房或浴室底板後面。</p>
            <h1>黑蟻</h1>
            <p>會在材料堆中建築螞蟻巢，如木材，石頭或紙板等。如在室內築巢時，它們通常會選擇於水源附近; 例如，在廚房和浴室。</p>
          `
        }, {
          name: '如何消滅它們',
          id: 5,
          imgpath: '',
          tag: '',
          html: `
            <h1 class="hdr">如何消滅它們</h1>
            <p>要徹底消滅螞蟻，關鍵是消滅整個螞蟻巢穴。 如果只是殺死眼前的螞蟻，其餘的螞蟻會繼續出末尋找食物和水源，以便奉給蟻后和與其他同伴分享。</p>
            <p>威滅速效殺蟻藥餌可以將巢穴內的螞蟻一網打盡。想了解更多有關威滅一網打盡的原理，<a href="#/preventiontips/insecticideguide">請按這裡</a>。</p>
          `
        }],
        selected: null,
        sortOption: null,
        filterOption: null,
        filterText: '',
        option: {
          getSortData: {
            id: 'id'
          },
          sortBy: 'id',
          getFilterData: {
            '顯示全部': function () {
              return true
            },
            '螞蟻': function (el) {
              return el.tag.match(/螞蟻$/)
            },
            '曱甴': function (el) {
              return el.tag.match(/曱甴$/)
            }
          }
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import "../styles/_vars.sass"
@import "../styles/_isotopeGrid.sass"

.generalPage
  padding-top: $topMenu-height

</style>
<style lang="sass">
@import "../styles/_vars.sass"
@import "../styles/_isotopeGridContents.sass"
</style>



// WEBPACK FOOTER //
// PIAnt.vue?740a8edc